import { createContext, ReactNode, useContext, useMemo } from 'react';

import { GlossaryItem } from '../../types/Glossary';

type GlossaryContextType = {
  analytics: Analytics | null;
  glossary: GlossaryItem[];
};

const GlossaryContext = createContext<GlossaryContextType>({
  analytics: null,
  glossary: [],
});

export const GlossaryContextProvider = ({
  analytics,
  children,
  glossary,
}: {
  analytics: Analytics;
  children: ReactNode;
  glossary: GlossaryItem[];
}) => {
  const value = useMemo(
    () => ({
      analytics,
      glossary,
    }),
    [analytics, glossary],
  );

  return (
    <GlossaryContext.Provider value={value}>
      {children}
    </GlossaryContext.Provider>
  );
};

export const useGlossary = () => useContext(GlossaryContext);
